/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import { notification } from 'antd';
import { fabric } from 'fabric';
import _, { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  containerMoving,
  getIndex,
  interactWithObjContainer,
  setStatusBeforeMovingObj,
} from '../../fabric_obj/container';
import { doubleClick, editControl, objectMoving, selectionClear } from '../../fabric_obj/customObj/handle/index';
import {
  UpdateAllPathsAssociatedWithObj,
  updatePathArrowOfObjectsInActiveSelection,
} from '../../fabric_obj/fabric_flowchart';
import {
  updateHeaderSwimLaneHorizontal,
  updateHeaderSwimLaneVertical,
} from '../../fabric_obj/containerObj/handle/editText';
import {
  addingControlPointsSwimLaneHorizontal,
  handleMouseDblClickSwimLaneHorizontal,
} from '../../fabric_obj/containerObj/handle/handleSwimLaneHorizontal';
import {
  addingControlPointsSwimLaneVertical,
  handleMouseDblClickSwimLaneVertical,
} from '../../fabric_obj/containerObj/handle/handleSwimLaneVertical';
import { connectLine, createLabel } from '../../fabric_obj/label';
import { addingControlPoints } from '../../fabric_obj/lineControl';
import {
  cleanObject,
  highlightControl,
  highlightPolyline,
  highlightPolylineSelected,
  turnOffHighLightPolyline,
  turnOffHighLightPolylineSelected,
  turnOffHighLightPort,
  updatePoints,
} from '../../fabric_obj/utils';
import { actions } from '../../redux';
import {
  setActiveType,
  updateZoomRatio,
  updateCommonSettings,
  setObjectName,
  setLayerAction,
  setObjectId,
  updateComponentSettings,
} from '../../redux/board/reducer';
import {
  ACTIVE_SELECTION,
  ACTIVE_SELECTION_ID,
  BORDER_LINE_ID,
  CANVAS_DEFAULT_SIZE,
  checkPointerInside,
  convertJsonToObject,
  createImageFromUrl,
  CUSTOM_GROUP_ID,
  drawBorderOnOver,
  drawBoundingBox,
  drawEditBorder,
  eventBus,
  generateId,
  generateImageHtmlId,
  getCurrentState,
  getCurrentViewCanvasSize,
  getLongestLineWidth,
  getObjCoords,
  getObjId,
  getOCoordsBasedOnBoundingBox,
  getSettingsUpdateFromBackgroundImage,
  getViewportTransform,
  GROUP,
  handleMovingEdgeOfBackgroundCanvas,
  IMAGE_HTML_ID,
  initAligningGuidelines,
  initCenteringGuidelines,
  isEdgeOfPage,
  ITEXT,
  NOTIFICATION_KEY,
  prepareCanvasBorders,
  processAlign,
  RECT,
  resetViewCanvas,
  textAlignInGroup,
  TEXTBOX,
  TEXT_GROUP_ID,
  TRIANGLE,
  ungroup,
  updateBackgroundImageFromPageSetting,
  URL_LIMIT_LENGTH,
} from '../../utils';
import {
  AUTO,
  BACKGROUND_EDGE_OPTIONS,
  CANVAS_ACTION,
  CANVAS_BACKGROUND_COLOR,
  CHART,
  CUSTOM_TEXT,
  FABRIC_CUSTOM_OBJECT,
  IMAGE,
  OVER_LINE_ID,
  PAGE_SETTING_DEFAULT,
  PATH,
  TEXT_AREA,
  TEXT_COMPONENT,
  VIEWPORT_TRANSFORM_DEFAULT,
  BUS_EVENTS,
  MOUSE_BUTTON,
} from '../../utils/constants';
import componentSettingsHook from './hooks/componentSettingsHook';
import drawingHook from './hooks/drawingHook';
import layerHook from './hooks/layerHook';
import styleHook from './hooks/styleHook';
import transformSettingHook from './hooks/transformSettingHook';
import './style.scss';
import { setIsContentChange } from '../../redux/stateManager/reducer';

let checkObj = true;
let stackOrder;
const offset = 20;

export default (initialState) => {
  const dispatch = useDispatch();
  const [oldTree, setOldTree] = useState(null);
  const [stateBeforeEditText, setStateBeforeEditText] = useState(null);
  const [refreshKey, setRefreshKey] = useState(generateId());
  const [state, _setState] = useState(initialState);
  const setState = (obj) => _setState((_state) => ({ ..._state, ...obj }));
  const pageSettings = useSelector((appState) => appState.pages.settings);

  const stateStack = useSelector((appState) => appState.stateManager.stateStack);
  const { onSelectionChanged, initCanvas, editStyle, editText } = styleHook();
  const { initCanvas: initDrawingCanvas } = drawingHook();
  const { initCanvas: initSettingCanvas } = componentSettingsHook();
  const { initCanvas: initCommonCanvas } = transformSettingHook();
  const { initCanvas: initLayerCanvas, contextState, setContextState, onUpdateHtmlComponent } = layerHook();

  //= ======== methods ============

  const updateBackgroundImage = () => {
    updateBackgroundImageFromPageSetting(pageSettings);
    if (!pageSettings.isLocked) {
      const settingUpdate = getSettingsUpdateFromBackgroundImage();
      const hasValueChange = Object.keys(settingUpdate).some((key) => settingUpdate[key] !== pageSettings[key]);
      if (hasValueChange) dispatch(actions.editPageSettings(settingUpdate));
    }
  };
  const updatePageContent = () => {
    updateBackgroundImage();
    dispatch(actions.updatePageContent(getCurrentState()));
  };
  const saveState = (optionalState) => {
    let filterState;
    if (!optionalState) {
      filterState = {
        ...getCurrentState(),
        objects: getCurrentState().objects.filter((obj) => obj.id !== OVER_LINE_ID && !obj.isNotObj),
      };
      if (stateStack.length <= 1) {
        dispatch(actions.updateCanvasStatesSaga(filterState));
      } else if (!_.isEqual(filterState, stateStack[stateStack.length - 1])) {
        dispatch(actions.updateCanvasStatesSaga(filterState));
      }
    } else {
      filterState = {
        ...optionalState,
        objects: optionalState.objects.filter((obj) => obj.id !== OVER_LINE_ID && !obj.isNotObj),
      };
      dispatch(actions.updateCanvasStatesSaga(filterState));
    }
  };

  const initial = () => {
    const canvas = new fabric.Canvas('canvas', {
      width: CANVAS_DEFAULT_SIZE.getWidth(),
      height: CANVAS_DEFAULT_SIZE.getHeight(),
      preserveObjectStacking: true,
      stopContextMenu: true,
      fireRightClick: true,
      fireMiddleClick: false,
      backgroundColor: '#fff',
    });

    window.canvas = canvas;
    prepareCanvasBorders(canvas);
    fabric.Object.prototype.set({
      transparentCorners: true,
      cornerSize: 8,
      cornerColor: '#007AFF',
    });

    canvas.hoverCursor = 'default';
    initAligningGuidelines({ canvas });
    initCenteringGuidelines({ canvas });
    setState({ canvas });
    initCanvas(canvas);
    initDrawingCanvas(canvas);
    initSettingCanvas(canvas);
    initCommonCanvas(canvas);
    initLayerCanvas(canvas);
  };

  const getAllStyles = (obj) => {
    let allStyles = [];
    const styleValues = Object.values(obj.styles);
    for (let i = 0; i < styleValues.length; i++) {
      const filterStyles = Object.values(styleValues[i]);
      Object.keys(styleValues[i]).forEach((key, index, keys) => {
        const cur = parseInt(key);
        const next = parseInt(keys[index + 1]);
        if (cur < 0) {
          filterStyles.splice(index, 1);
        } else if (next && cur - next !== -1) {
          filterStyles.splice(index + 1, 1);
        }
      });
      if (styleValues.length > 1) {
        filterStyles.pop();
      }
      allStyles = allStyles.concat(filterStyles);
    }
    return allStyles;
  };

  const checkAllEquals = (key, value, allStyles) => {
    const values = allStyles.reduce((a, c) => a.concat(c[key]), []);
    return values.every((v) => v === value);
  };

  const checkTextStyle = (obj) => {
    let result = {};
    if (!obj) return;
    const atts = [
      'fill',
      'fontSize',
      'textBackgroundColor',
      'fontFamily',
      'fontWeight',
      'fontStyle',
      'textAlign',
      'linethrough',
      'listType',
      'underline',
      'simulateList',
      'opacity',
    ];
    const allStyles = getAllStyles(obj);
    if (obj.styles[0]) {
      atts.forEach((item) => {
        const firstStyleValue = Object.values(obj.styles[0])[0][item];
        const isEveryStyle = checkAllEquals([item], firstStyleValue, allStyles);
        result = { ...result, [item]: isEveryStyle ? obj[item] : '' };
      });
    } else {
      atts.forEach((item) => {
        result = { ...result, [item]: obj[item] };
      });
    }
    return result;
  };

  const getAppearanceSettings = (obj, type) => {
    let result = {};
    if ([GROUP, ACTIVE_SELECTION].includes(type) && !obj.id?.includes(TEXT_GROUP_ID)) {
      const o = obj.getObjects().length === 1 || obj.colorSetting ? obj.getObjects()[0] : obj;
      const atts = [
        'fill',
        'opacity',
        'stroke',
        'strokeWidth',
        'strokeDashArray',
        'strokeLineCap',
        'rx',
        'ry',
        'shadow',
        'dirty',
      ];
      atts.forEach((item) => {
        result = { ...result, [item]: item === 'dirty' ? true : o[item] };
      });
      // result = { opacity: obj.opacity, shadow: obj.shadow };
    } else if (obj.id?.includes(TEXT_GROUP_ID) || obj.type === CUSTOM_TEXT || obj.type === TEXT_COMPONENT) {
      const o =
        obj?._objects.length === 1 || obj.colorSetting || obj.name === TEXT_AREA || obj.type === TEXT_COMPONENT
          ? obj?._objects.find((i) => ![TEXTBOX, ITEXT].includes(i.type))
          : obj;
      const atts = [
        'fill',
        'opacity',
        'stroke',
        'strokeWidth',
        'strokeDashArray',
        'strokeLineCap',
        'rx',
        'ry',
        'shadow',
        'dirty',
      ];
      atts.forEach((item) => {
        result = { ...result, [item]: item === 'dirty' ? true : o[item] };
      });
      const text = obj?._objects.find((o) => [TEXTBOX, ITEXT].includes(o.type));
      result.textSettings = checkTextStyle(text);
    } else if ([TEXTBOX, ITEXT].includes(type)) {
      result = checkTextStyle(obj);
    } else if ([PATH].includes(type)) {
      const atts = ['fill', 'opacity', 'stroke', 'strokeWidth', 'strokeDashArray', 'strokeLineCap', 'shadow'];
      atts.forEach((item) => {
        result = { ...result, [item]: obj[item] };
      });
    } else {
      const atts = [
        'fill',
        'opacity',
        'stroke',
        'strokeWidth',
        'strokeDashArray',
        'strokeLineCap',
        'rx',
        'ry',
        'shadow',
      ];
      atts.forEach((item) => {
        result = { ...result, [item]: obj[item] };
      });
    }
    dispatch(updateComponentSettings(result || {}));
  };

  const getCommonSettingsFromSelect = (obj) => {
    const coords = {
      x: obj.left || 0,
      y: obj.top || 0,
      width: obj.width || 0,
      height: obj.height || 0,
      angle: obj.angle || 0,
      scaleX: obj.scaleX || 1,
      scaleY: obj.scaleY || 1,
    };
    dispatch(updateCommonSettings(coords));
  };

  const handleTextAlign = (pos) => {
    const { canvas } = window;
    let { editObj } = state;
    const active = canvas.getActiveObject();
    const id = active?.id;
    if (
      editObj?.type !== CUSTOM_TEXT &&
      editObj?.type !== TEXT_COMPONENT &&
      (editObj ||
        (id &&
          ((`${id}`.includes(CUSTOM_GROUP_ID) && active.type !== TEXT_COMPONENT) || `${id}`.includes(TEXT_GROUP_ID))))
    ) {
      let isEdit = true;
      if (id && (`${id}`.includes(CUSTOM_GROUP_ID) || `${id}`.includes(TEXT_GROUP_ID))) isEdit = false;
      if (!isEdit) editObj = active;
      textAlignInGroup(canvas, editObj, pos, dispatch);
      if (isEdit) {
        canvas.discardActiveObject();
        editObj.set({
          width: editObj.width * editObj.scaleX,
          height: editObj.height * editObj.scaleY,
          scaleX: 1,
          scaleY: 1,
        });
        setState({ editObj });
        ungroup(editObj, canvas);
        const dimensionText = editObj.getObjects()[1];
        dimensionText.set({ hasBorders: false });
        canvas.setActiveObject(dimensionText);
        dimensionText.enterEditing();
        const objs = canvas.getObjects();
        objs.forEach((item) => {
          if (item.id === editObj.id) canvas.remove(item);
        });
        canvas.renderAll();
      }
    } else {
      const active = canvas.getActiveObject();
      if ([TEXTBOX, ITEXT, CUSTOM_TEXT, TEXT_COMPONENT].includes(active.type)) {
        if (active.type === TEXTBOX && (editObj?.type === TEXT_COMPONENT || editObj?.type === CUSTOM_TEXT)) {
          if (['top', 'middle', 'bottom'].includes(pos)) editObj.textAlignVertical = pos;
          else editObj.getTextObj().set({ textAlign: pos, width: active.width });
          const { top, left } = editObj.updateTextAlign();
          active.set({ top, left });
        } else if (active.isUMLObject || active.type === CUSTOM_TEXT || active.type === TEXT_COMPONENT) {
          if (['top', 'middle', 'bottom'].includes(pos)) active.textAlignVertical = pos;
          else {
            let textObj = active;
            if ([CUSTOM_TEXT, TEXT_COMPONENT].includes(active.type)) textObj = active.getTextObj();
            textObj.set({ textAlign: pos, width: active.width });
          }
        } else active.textAlign = pos;
        canvas.renderAll();
      }
    }
  };

  const handleGroupAlignWithCanvas = (type) => {
    const { canvas } = window;
    const active = canvas.getActiveObject();
    saveState();
    processAlign(type, canvas);
    setState({
      alignPosition: {
        left: active.aCoords.tl.x,
        top: active.aCoords.tl.y,
      },
    });

    canvas.renderAll();
    updatePageContent();
  };

  const getAllFlatObjects = () => {
    const rootObjects = cloneDeep(window.canvas.getObjects());
    const flatObjects = (obj) =>
      obj._objects && obj._objects.length ? obj._objects.map((oo) => flatObjects(oo)).flat() : obj;
    const results = rootObjects.map((e) => flatObjects(e));
    return results.flat();
  };

  const reGroup = () => {
    if (oldTree) {
      const flatObjects = getAllFlatObjects();

      const resetRootObject = (o) => {
        const dontTouchItem = window.canvas.getObjects().find((e) => e.id === o.id);
        if (dontTouchItem) return;

        const resetObject = (obj) => {
          if (
            obj.isUMLComponent ||
            [
              GROUP,
              CUSTOM_TEXT,
              TEXT_COMPONENT,
              FABRIC_CUSTOM_OBJECT.rectWithText,
              FABRIC_CUSTOM_OBJECT.rectTextSVG,
            ].includes(obj.type)
          ) {
            const availableGroup = window.canvas.getObjects().find((e) => e.id === obj.id);
            if (availableGroup) {
              window.canvas.remove(availableGroup);
              return availableGroup;
            }

            const childGroup = obj._objects.map(resetObject).filter((e) => e);
            return childGroup.length > 0 ? new fabric.Group(childGroup, { id: obj.id, type: GROUP }) : undefined;
          }
          const newObject = flatObjects.find((e) => e.id === obj.id);
          return newObject;
        };

        if (o.type === GROUP && o._objects && o._objects.length) {
          const newObjResult = o._objects.map(resetObject).filter((e) => e);
          if (newObjResult.length === 1) {
            const newObj = newObjResult[0];
            newObj.set({ id: o.id });
            window.canvas.add(newObj);
          } else {
            const newGroup = new fabric.Group(newObjResult, { id: o.id, name: o.name, type: GROUP });
            window.canvas.add(newGroup);
          }
        }
      };

      oldTree.forEach(resetRootObject);

      const items = window.canvas.getObjects();
      for (let i = 0; i < items.length; i++) {
        if ((oldTree || []).every((o) => o.id !== items[i].id)) {
          window.canvas.remove(items[i]);
        }
      }

      window.canvas.renderAll();
      setOldTree(null);
      setState({ isShowAlign: false, editGroup: null });
      dispatch(setActiveType(null));
      dispatch(updateComponentSettings(null));
    }
  };

  const onSelectionClear = (e) => {
    console.log('onSelectionClear', e);
    eventBus.emit(CANVAS_ACTION.SELECTED_OBJECT);
    if (selectionClear(e)) return;
    updateHeaderSwimLaneHorizontal(e);
    updateHeaderSwimLaneVertical(e);
    updateBackgroundImage();
  };
  const onMouseDown = (options) => {
    if (
      isEdgeOfPage(options.target) ||
      (options.target && !options.target.canvas && options?.target?.type === FABRIC_CUSTOM_OBJECT.swimLaneVertical) ||
      (options.target && !options.target.canvas && options?.target?.type === FABRIC_CUSTOM_OBJECT.swimLaneHorizontal)
    )
      return;

    setStatusBeforeMovingObj(options);
    const { canvas } = window;
    const { editGroup } = state;
    const { target } = options;
    if (target?.isContainer) canvas.sendToBack(target);
    console.log('--------onMouseDown--------', options.target, !!editGroup);
    if (target?.id && `${target?.id}`.includes(CHART)) {
      setContextState({
        editorInformation: {
          data: target.htmlContent,
          objectId: target.id,
        },
      });
    }
    canvas.drawOnOver = false;
    drawBorderOnOver(canvas);
    const isRightClick = options.button === MOUSE_BUTTON.right;
    if (isRightClick) {
      if (contextState.isEdit) return;
      const pointer = canvas.getPointer(options.e, true);
      setContextState({
        isShowMenu: true,
        menuPosition: { x: pointer.x, y: pointer.y },
        isHoverSuggestShape: false,
      });
    } else {
      setContextState({
        menuPosition: {},
        isShowMenu: false,
        isShowEditor: false,
        isHoverSuggestShape: false,
      });
      setState({ isShowChartEdit: false });
    }
    if (target) {
      target.set({ objectCaching: false });
      toogleChartMenu(target?.id?.includes(IMAGE_HTML_ID) ? target : null);
    } else if (contextState.isShowEditor) {
      setContextState({ editorInformation: {}, isShowEditor: false });
    } else {
      toogleChartMenu();
      setContextState({ isEdit: false });
      reGroup();
    }
  };
  const onMouseUp = (options) => {
    const { target } = options;
    if (isEdgeOfPage(target)) {
      dispatch(actions.updatePageContent(getCurrentState()));

      setRefreshKey(generateId());
      return;
    }
    if (!target) cleanObject();
    const activeObj = window.canvas.getActiveObject();
    if (activeObj && activeObj.type === FABRIC_CUSTOM_OBJECT.swimLaneHorizontal) {
      addingControlPointsSwimLaneHorizontal(activeObj);
    }
    if (activeObj && activeObj.type === FABRIC_CUSTOM_OBJECT.swimLaneVertical) {
      addingControlPointsSwimLaneVertical(activeObj);
    }
    if (activeObj && activeObj.type === FABRIC_CUSTOM_OBJECT.polyline) addingControlPoints(activeObj);
    if (activeObj && activeObj.type === FABRIC_CUSTOM_OBJECT.polyline) highlightPolylineSelected(activeObj);
    else turnOffHighLightPolylineSelected();

    if (target) {
      if (target.id !== undefined && target.type === GROUP && target.id.includes(CUSTOM_GROUP_ID)) {
        const cz = window.canvas.getZoom();
        setState({
          isShowAlign: true,
          alignPosition: {
            left: target.aCoords.bl.x * cz,
            top: target.aCoords.bl.y * cz,
          },
        });
      }
    } else if (!activeObj || !activeObj.id) {
      dispatch(setActiveType(null));
      dispatch(updateCommonSettings(null));
      dispatch(setLayerAction(null));
      eventBus.emit('on-change-edit-text', { editText: null, editStyle: [] });
    }
    if (activeObj) updatePageContent();
  };
  const onMouseOver = (e) => {
    const { canvas } = window;
    const { editGroup, editObj } = state;
    let { target } = e;
    if (isEdgeOfPage(target)) {
      target.set({ selectable: true });
      target.setCoords();
      return;
    }
    if (checkObj) {
      checkObj = false;
      cleanObject();
    }
    if (e.target && e.target.__corner && e.target.__corner.search('Port') !== -1) highlightControl(e.target.__corner);
    if (target && target.type === FABRIC_CUSTOM_OBJECT.polyline && !target.isNotObj) {
      target = updatePoints(target);
      highlightPolyline(target);
      return;
    }
    turnOffHighLightPolyline();

    const active = canvas.getActiveObject();
    const obj = e.target;
    if (!obj || editGroup || editObj) return;
    if (active && active.id === obj.id) return;
    if (!obj.id) return;
    canvas.drawOnOver = true;
    drawBorderOnOver(canvas, obj);
  };
  const onMouseOut = (e) => {
    const { canvas } = window;
    window.canvas.drawOnOver = false;
    const obj = e.target;
    if (isEdgeOfPage(obj)) {
      obj.set(BACKGROUND_EDGE_OPTIONS);
      obj.setCoords();
    }
    drawBorderOnOver(canvas, obj);
    turnOffHighLightPort(obj);
    turnOffHighLightPolyline();
  };
  const onDragOver = ({ e }) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.dataTransfer.dropEffect = 'copy';
    return false;
  };
  const onObjectMoved = (e) => {
    console.log('Moved', e);
    if (e.target?.isDiagram) UpdateAllPathsAssociatedWithObj(e);
  };
  const onObjectRotating = (e) => {
    if (e.target && e.target.isDiagram) UpdateAllPathsAssociatedWithObj(e);
  };
  const onDrop = async (options) => {
    if (options) {
      toogleChartMenu();
      if (options.stopPropagation) {
        options.stopPropagation();
      }
      let data = options.e.dataTransfer.getData('on-element-drag');
      if (typeof InstallTrigger !== 'undefined') {
        document.addEventListener('drop', (e) => {
          e.preventDefault();
          if (e.stopPropagation) {
            e.stopPropagation();
          }
        });
      }
      saveState();
      data = JSON.parse(data);
      const { content = {} } = data;
      content.name = data.name;
      let obj = null;
      const pointer = window.canvas.getPointer(options.e);
      const { translationX, translationY, scaleX, scaleY } = getViewportTransform();
      const coords = {
        left: pointer.x || -translationX / scaleX,
        top: pointer.y || -translationY / scaleY,
      };
      if (content.id && content.id.includes(IMAGE_HTML_ID)) {
        const img = document.createElement('img');
        img.onload = () => {
          obj = new fabric.Image(img, {
            width: content.width,
            height: content.height,
          });
          obj.set({ ...content });
          const newId = generateImageHtmlId(content.id);
          obj.set({ id: newId });
          obj.set(coords);
          obj.set({ htmlContent: content.htmlContent, src: content.src, colorSetting: content.colorSetting });
          window.canvas.add(obj);
          window.canvas.setActiveObject(obj);
          window.canvas.renderAll();
          updatePageContent();
        };
        img.src = content.src;
      } else if (content.type === IMAGE && content.src?.length < URL_LIMIT_LENGTH) {
        createImageFromUrl(content.src, { ...content, ...coords }, (imageObject) => {
          window.canvas.add(imageObject);
          window.canvas.setActiveObject(imageObject);
          window.canvas.renderAll();
          dispatch(setIsContentChange(true));
          updatePageContent();
        });
        return;
      } else {
        obj = await convertJsonToObject(content);
        getObjId(obj);
        obj.set(coords);
        // obj = createCustomObj();
        window.canvas.add(obj);
        if (obj.isContainer) window.canvas.sendToBack(obj);
        else window.canvas.bringToFront(obj);
        if (obj.type === FABRIC_CUSTOM_OBJECT.polyline) obj = updatePoints(obj);
        window.canvas.setActiveObject(obj);
        window.canvas.renderAll();
      }
      if (obj && obj.id && obj.id.includes(ACTIVE_SELECTION_ID)) {
        window.canvas.discardActiveObject();
        ungroup(obj, window.canvas, true);
        const ids = obj.getObjects().map((o) => o.id);
        const actives = window.canvas.getObjects().filter((o) => ids.includes(o.id));
        const sel = new fabric.ActiveSelection(actives, {
          canvas: window.canvas,
        });
        window.canvas.setActiveObject(sel);
        window.canvas.requestRenderAll();
      }
      dispatch(setIsContentChange(true));
      updateBackgroundImageFromPageSetting({
        ...getSettingsUpdateFromBackgroundImage(),
        isLocked: pageSettings.isLocked,
      });

      window.canvas.renderAll();
      reloadOldtree(obj);
    }
  };

  const onSelect = () => {
    eventBus.emit(CANVAS_ACTION.SELECTED_OBJECT);
    const obj = window.canvas.getActiveObject();
    const type = obj.type || null;
    const objectName = obj.name || '';
    if (isEdgeOfPage(obj)) {
      dispatch(setActiveType(null));
      dispatch(setObjectName(null));
      dispatch(setObjectId(null));
      dispatch(setLayerAction(null));
      return;
    }
    dispatch(setActiveType(type));
    dispatch(setObjectName(objectName));
    dispatch(setObjectId(obj.id));
    dispatch(setLayerAction(null));
    getCommonSettingsFromSelect(obj);
    getAppearanceSettings(obj, type);
  };
  const onSelectUpdate = (options) => {
    if (isEdgeOfPage(window.canvas.getActiveObject())) {
      dispatch(setActiveType(null));
      dispatch(setObjectName(null));
      dispatch(setObjectId(null));
      dispatch(setLayerAction(null));
      return;
    }
    updateBackgroundImageFromPageSetting(pageSettings);
    if (selectionClear(options)) return;
    updateHeaderSwimLaneHorizontal(options);
    updateHeaderSwimLaneVertical(options);

    const obj = window.canvas.getActiveObject();
    if (!obj) return;
    const type = obj.type || null;
    const objectName = obj.name || '';

    dispatch(setObjectName(objectName));
    dispatch(setObjectId(obj.id));
    dispatch(setActiveType(type));
    dispatch(setLayerAction(null));
    getCommonSettingsFromSelect(obj);
    getAppearanceSettings(obj, type);
  };

  const updateViewTransform = (event) => {
    const { x, y } = window.canvas.getPointer(event, true);
    const { width: viewWidth, height: viewHeight } = getCurrentViewCanvasSize();
    const eps = 10;
    const [isOutTop, isOutBot, isOutLeft, isOutRight] = [y < eps, y > viewHeight - eps, x < eps, x > viewWidth - eps];
    if (!isOutTop && !isOutBot && !isOutLeft && !isOutRight) return;
    let deltaX = 0;
    let deltaY = 0;
    if (isOutLeft) deltaX += 5;
    else if (isOutRight) deltaX -= 5;
    if (isOutTop) deltaY += 5;
    else if (isOutBot) deltaY -= 5;
    const [scaleX, skewX, skewY, scaleY, translationX, translationY] = window.canvas.viewportTransform;
    window.canvas.setViewportTransform([scaleX, skewX, skewY, scaleY, translationX + deltaX, translationY + deltaY]);
  };
  const onModified = (e) => {
    if (isEdgeOfPage(e.target)) return;
    if (e.target.type === 'activeSelection') updatePathArrowOfObjectsInActiveSelection(e.target);
    // saveStateAndProgress();
    updatePageContent();

    const obj = e.target;
    if (obj.type === FABRIC_CUSTOM_OBJECT.polyline) {
      window.canvas.getObjects().map((o) => {
        if (o.id === obj.id) window.canvas.setActiveObject(o);
        return o;
      });
    }
    if (obj.id !== undefined && obj.type === GROUP && obj.id.includes(CUSTOM_GROUP_ID)) {
      const cz = window.canvas.getZoom();
      setState({
        isShowAlign: true,
        alignPosition: {
          left: obj.aCoords.bl.x * cz,
          top: obj.aCoords.bl.y * cz,
        },
      });
    }
  };
  const onObjectScaling = (options) => {
    const { target } = options;
    if (editControl()) return;
    if (target && target.isDiagram) UpdateAllPathsAssociatedWithObj(options);
    if ([RECT, TRIANGLE].includes(target.type)) {
      target.set({
        width: target.width * target.scaleX,
        height: target.height * target.scaleY,
        scaleX: 1,
        scaleY: 1,
        objectCaching: false,
      });
      return;
    }
    if (target.type === GROUP && target.id.includes(TEXT_GROUP_ID)) {
      const o = target.getObjects().find((t) => [TEXTBOX, ITEXT].includes(t.type));
      if (target.scaleX < 1) {
        o.scaleX = 1 + (1 - target.scaleX);
      } else {
        o.scaleX = 1 / target.scaleX;
      }
      if (target.scaleY < 1) {
        o.scaleY = 1 + (1 - target.scaleY);
      } else {
        o.scaleY = 1 / target.scaleY;
      }
      o.set({
        width: target.getScaledWidth() - offset,
      });
    }
  };
  const onObjectScaled = (options) => {
    console.log('scaled', options);
    if (editControl()) return;
    const { target } = options;
    if (target && target.type === TEXTBOX && (target.scaleX !== 1 || target.scaleY !== 1)) {
      const width = target.getScaledWidth();
      const height = target.getScaledHeight();
      target.set({
        scaleX: 1,
        scaleY: 1,
        width,
        height,
      });
      target.set({ height });
    }
  };
  const onObjectMoving = (options) => {
    if (pageSettings?.isLocked && isEdgeOfPage(options.target)) {
      handleMovingEdgeOfBackgroundCanvas(options.target, options.pointer);
      dispatch(actions.editPageSettings(getSettingsUpdateFromBackgroundImage()));
      updateViewTransform(options.e);
      return;
    }
    toogleChartMenu();
    updateBackgroundImageFromPageSetting(pageSettings);
    updateViewTransform(options.e);
    if (objectMoving(options)) return;
    const { canvas } = window;
    const { editGroup } = state;
    const { target } = options;
    turnOffHighLightPolyline();
    turnOffHighLightPolylineSelected();
    if (editGroup) {
      const flattenIds = editGroup.getObjects().map((f) => f.id);
      const objs = canvas.getObjects().filter((o) => flattenIds.includes(o.id));
      const aCoords = objs.map((o) => o.aCoords);
      const coords = getObjCoords(aCoords);
      drawEditBorder(coords, canvas);
    }

    if (target?.type === FABRIC_CUSTOM_OBJECT.polyline || target?.isContainer) {
      containerMoving(options);
    } else if (target?.isDiagram) {
      UpdateAllPathsAssociatedWithObj(options);
    }
    if (target?.type === TEXTBOX && target?.name === FABRIC_CUSTOM_OBJECT.label) {
      connectLine(target);
    }
    if (!target.isContainer && !target.isControlPoint) {
      interactWithObjContainer(target);
    }
  };

  let antiSpamUpdate = null;
  const onObjectAdd = () => {
    if (pageSettings.isLocked || !state.isGetPageContent) return;
    if (antiSpamUpdate) {
      clearTimeout(antiSpamUpdate);
      antiSpamUpdate = null;
    }
    antiSpamUpdate = setTimeout(() => {
      updateBackgroundImage();
      antiSpamUpdate = null;
    }, 100);
  };

  const toogleChartMenu = (obj) => {
    if (obj && obj?.id?.includes(CHART)) {
      const { mb } = getOCoordsBasedOnBoundingBox(obj);
      setState({
        isShowChart: true,
        chartPosition: {
          left: mb.x,
          top: mb.y,
        },
      });
    } else {
      setState({
        isShowChart: false,
        chartPosition: { left: 999999, top: 999999 },
        isShowChartEdit: false,
      });
    }
  };

  const onDbClick = (options) => {
    console.log('dbClick', options);
    if (doubleClick(options)) return;
    handleMouseDblClickSwimLaneHorizontal(options);
    handleMouseDblClickSwimLaneVertical(options);
    const { target } = options;
    if (target?.id?.includes(IMAGE_HTML_ID) && target.id.includes(CHART)) {
      toogleChartMenu();
      setState({ isShowChartEdit: true });
      return;
    }
    if (target && target.polylineId) {
      target.set({
        centerX: target.left + target.width / 2,
        centerY: target.top + target.height / 2,
      });
      return;
    }
    if (target && target.type === FABRIC_CUSTOM_OBJECT.polyline) {
      const pointer = window.canvas.getPointer(options);
      if (target.isNotObj && target.copyId) {
        window.canvas.getObjects().map((e) => {
          if (
            e.type === FABRIC_CUSTOM_OBJECT.polyline &&
            e.id === target.copyId &&
            !e.isNotObj &&
            !(target.name && target.name.search('Line') !== -1)
          ) {
            createLabel(e, pointer.x, pointer.y);
          }
          return e;
        });
      } else if (!(target.name && target.name.search('Line') !== -1)) createLabel(target, pointer.x, pointer.y);
      return;
    }
    if ([GROUP, TEXTBOX, ITEXT, IMAGE, CUSTOM_TEXT, TEXT_COMPONENT].includes(target?.type)) {
      const obj = window.canvas.getActiveObject();
      const { tl } = getOCoordsBasedOnBoundingBox(obj);
      setContextState({ editPosition: { left: tl.x, top: tl.y } });
      const { id } = target;
      if ((id && `${id}`.includes(TEXT_GROUP_ID)) || obj.type === CUSTOM_TEXT || obj.type === TEXT_COMPONENT) {
        stackOrder = getIndex(obj);
        setState({ editObj: obj });
        ungroup(obj, window.canvas);
        const textObj = obj._objects.find((obj) => obj.type === TEXTBOX);
        textObj.set({ hasBorders: false, visible: true });
        window.canvas.setActiveObject(textObj);
        textObj.enterEditing();
        textObj.selectAll();
        if (obj.type === CUSTOM_TEXT) obj.drawBoundingHiddenRect();
      } else if (id && `${id}`.includes(CUSTOM_GROUP_ID)) {
        const objs = window.canvas.getObjects();
        ungroup(obj, window.canvas, true);
        const pointer = window.canvas.getPointer();
        const active = obj.getObjects().find((o) => checkPointerInside(pointer, o.lineCoords));
        if (active) window.canvas.setActiveObject(active);
        window.canvas.renderAll();
        setState({ editGroup: obj });
        setOldTree((old) => (!old ? cloneDeep(objs) : old));
      } else if (id && `${id}`.includes(IMAGE_HTML_ID)) {
        setContextState({
          isShowEditor: !id.includes(CHART),
          editorInformation: {
            x: tl.x,
            y: tl.y,
            w: Math.max(120, obj.width),
            h: Math.max(60, obj.height),
            data: obj.htmlContent,
            objectId: id,
            submit: false,
          },
        });
      }
    }
  };

  const onEditingExited = () => {
    const { editObj } = state;
    setContextState({ isEdit: false, editPosition: { top: -100, left: -100 } });
    if (editObj) {
      if (editObj.type === CUSTOM_TEXT) editObj.drawCustomText(editObj, stackOrder);
      else if (editObj.type === TEXT_COMPONENT) editObj.drawTextComponent(editObj, stackOrder);
      else drawBoundingBox(editObj, dispatch, stackOrder);
      setState({ editObj: null });
    }
    updatePageContent();
    setStateBeforeEditText(null);
  };

  const onUpdatePositionMenuEditor = () => {
    if (
      contextState.isEdit ||
      contextState.isShowEditor ||
      state.isShowAlign ||
      state.isShowChart ||
      state.isShowColor
    ) {
      const object = window.canvas.getActiveObject();
      let { tl, mt, mb } = getOCoordsBasedOnBoundingBox(object);
      if (contextState.isEdit) {
        if (object?.isUMLObject) {
          const parentObj = window.canvas.getObjects().find((o) => o.id === object.parentId);
          tl = getOCoordsBasedOnBoundingBox(parentObj).tl;
        }
        setContextState({
          editPosition: {
            left: tl.x,
            top: tl.y,
          },
        });
      }
      if (contextState.isShowEditor) {
        setContextState({
          editorInformation: {
            x: tl.x,
            y: tl.y,
            w: Math.max(120, object.width),
            h: Math.max(60, object.height),
          },
        });
      }
      if (state.isShowAlign) {
        setState({
          isShowAlign: true,
          alignPosition: {
            left: mt.x,
            top: mt.y,
          },
        });
      }
      if (state.isShowChart) {
        setState({
          isShowChart: true,
          chartPosition: {
            left: mb.x,
            top: mb.y,
          },
        });
      }
      if (state.isShowColor) {
        setState({
          isShowColor: true,
          colorPosition: {
            left: mt.x,
            top: mt.y,
          },
        });
      }
    }
  };

  const onEditingEntered = () => {
    console.log('onEditingEntered', window.canvas.getActiveObject().text);
    const obj = window.canvas.getActiveObject();
    const { tl } = obj.oCoords;
    if (obj?.isLabelComponent) {
      obj.set({ originalWidth: obj.width });
    }
    setContextState({
      isEdit: true,
      editPosition: {
        left: tl.x,
        top: tl.y,
      },
    });
  };
  const onTextChanged = (opts) => {
    console.log('text changed');
    const { target } = opts;

    if (target?.isLabelComponent) {
      const longestLineWidth = Math.max(getLongestLineWidth(), target.originalWidth);
      target.set({ width: longestLineWidth });
      target.setCoords();
      const { editObj } = state;
      editObj.set({ width: target.width });
      setState({ editObj });
    }

    if (state?.editObj?.type === CUSTOM_TEXT && state?.editObj?.textMode.height === AUTO) {
      const textObj = state.editObj.getTextObj();
      const rectObj = state.editObj.getRectObj();
      let { x, y } = textObj.getCenterPoint();
      if (target?.isLabelComponent && textObj.width < rectObj.width) {
        const { x: x2, y: y2 } = new fabric.Textbox(textObj.text, {
          ...JSON.parse(JSON.stringify(textObj)),
          width: rectObj.width,
        }).getCenterPoint();
        x = x2;
        y = y2;
      }
      rectObj.set({
        top: y,
        left: x,
        originY: 'center',
        originX: 'center',
        width: Math.max(textObj.width, rectObj.width),
        height: textObj.height,
      });
      const textPosition = textObj.getCoords(true)[0];
      state.editObj.set({ top: textPosition.y, left: textPosition.x });
    }

    updatePageContent();

    if (target && target.polylineId && target.centerX) {
      target.set({ left: target.centerX - target.width / 2 });
      target.set({ top: target.centerY - target.height / 2 });
      target.setCoords();
    }
  };
  const onPathCreated = (opts) => {
    const { path } = opts;
    path.fill = 'transparent';
    path.id = generateId();
    if (path.width < 1 && path.height < 1) {
      eventBus.emit('on-drawing-done');
      window.canvas.remove(path);
    }
  };

  const beforeTransform = () => {
    if (contextState.isEdit) return;
    saveState();
  };

  const addEditBorder = () => {
    const { canvas } = window;
    const { editGroup } = state;

    const coords = editGroup.aCoords;
    const { tl, tr, bl, br } = coords;
    canvas.line1.set({
      x1: tl.x,
      y1: tl.y,
      x2: tr.x,
      y2: tr.y,
    });
    canvas.line2.set({
      x1: tr.x,
      y1: tr.y,
      x2: br.x,
      y2: br.y + 2,
    });
    canvas.line3.set({
      x1: br.x + 2,
      y1: br.y,
      x2: bl.x,
      y2: bl.y,
    });
    canvas.line4.set({
      x1: bl.x,
      y1: bl.y,
      x2: tl.x,
      y2: tl.y,
    });
    canvas.add(canvas.line1, canvas.line2, canvas.line3, canvas.line4);
  };
  const removeEditBorder = () => {
    const { canvas } = window;
    const lines = canvas.getObjects().filter((o) => o.type === 'line' && o.id === BORDER_LINE_ID);
    canvas.remove(...lines);
  };
  const reloadOldtree = (value) => {
    if (!oldTree) return;
    setOldTree((old) => [...old, value]);
  };

  // TODO consider to use or not when zoom
  // const onZoom = () => {
  //   const { canvas } = window;
  //   removeEditBorder();
  //   canvas.discardActiveObject();
  // };

  // =========== useEffect =======
  useEffect(() => {
    if (contextState.isEdit || contextState.isShowEditor || state.isShowAlign || state.isShowChart) {
      eventBus.on(BUS_EVENTS.UPDATE_POSITION_MENU_EDITOR, onUpdatePositionMenuEditor);
    }
    return () => {
      eventBus.off(BUS_EVENTS.UPDATE_POSITION_MENU_EDITOR, onUpdatePositionMenuEditor);
    };
  }, [contextState.isEdit, contextState.isShowEditor, state.isShowAlign, state.isShowColor, state.isShowChart]);

  useEffect(() => {
    initial();
    if (window.canvas) {
      try {
        setContextState({
          isShowMenu: false,
          editorInformation: {},
          isShowEditor: false,
          isShowChartEdit: false,
          isEdit: false,
          editPosition: {},
          editStyle: {},
          editText: {},
        });
        setState({ isGetPageContent: true });
        window.canvas.clear();
        window.canvas.targetFindTolerance = 4;
        window.canvas.setBackgroundColor(CANVAS_BACKGROUND_COLOR, () => {});
        saveState();
        updateBackgroundImageFromPageSetting(PAGE_SETTING_DEFAULT);
        const settingUpdate = getSettingsUpdateFromBackgroundImage();
        dispatch(actions.editPageSettings(settingUpdate));
        window.canvas.setViewportTransform(VIEWPORT_TRANSFORM_DEFAULT);
        resetViewCanvas();
        saveState();
        setState({ isGetPageContent: false });
        const zoom = VIEWPORT_TRANSFORM_DEFAULT[0] * 100;
        dispatchZoom(zoom);
      } catch (e) {
        console.log('---------load app', e);
        notification.info({
          key: NOTIFICATION_KEY,
          message: 'Something went wrong. Please reload app.',
          duration: 5000,
        });
      }
    }
    return () => {};
  }, []);
  useEffect(() => {
    const { canvas } = window;
    const { editGroup } = state;
    canvas.renderAll();
    if (editGroup) {
      addEditBorder();
    } else if (canvas) {
      removeEditBorder();
      setState({ isShowAlign: false });
    }
  }, [state.editGroup]);

  useEffect(() => {
    // const mainBoard = document.getElementById('mo-main-board');
    const { canvas } = window;
    if (canvas) {
      eventBus.on('handle-group-alignment', handleGroupAlignWithCanvas);
      eventBus.on('handle-text-alignment', handleTextAlign);

      eventBus.on('save-canvas-state', saveState);
      eventBus.on('reload-oldTree', reloadOldtree);
      eventBus.on('regroup', reGroup);

      canvas.on('before:transform', beforeTransform);
      canvas.on('drop', onDrop);
      canvas.on('dragover', onDragOver);
      canvas.on('mouse:down', onMouseDown);
      canvas.on('mouse:up', onMouseUp);
      canvas.on('mouse:over', onMouseOver);
      canvas.on('mouse:out', onMouseOut);
      canvas.on('object:moving', onObjectMoving);
      canvas.on('object:added', onObjectAdd);
      canvas.on('object:scaling', onObjectScaling);
      canvas.on('object:scaled', onObjectScaled);
      canvas.on('object:moved', onObjectMoved);
      canvas.on('object:rotating', onObjectRotating);
      canvas.on('selection:created', onSelect);
      canvas.on('object:modified', onModified);
      canvas.on('selection:updated', onSelectUpdate);
      canvas.on('selection:cleared', onSelectionClear);
      canvas.on('mouse:dblclick', onDbClick);
      canvas.on('text:selection:changed', onSelectionChanged);
      canvas.on('text:editing:exited', onEditingExited);
      canvas.on('text:editing:entered', onEditingEntered);
      canvas.on('text:changed', onTextChanged);
      canvas.on('path:created', onPathCreated);
    }
    return () => {
      if (canvas) {
        eventBus.off('handle-group-alignment', handleGroupAlignWithCanvas);
        eventBus.off('handle-text-alignment', handleTextAlign);

        eventBus.off('save-canvas-state', saveState);
        eventBus.off('reload-oldTree', reloadOldtree);
        eventBus.off('regroup', reGroup);

        canvas.off('before:transform', beforeTransform);
        canvas.off('drop', onDrop);
        canvas.off('dragover', onDragOver);
        canvas.off('mouse:down', onMouseDown);
        canvas.off('mouse:up', onMouseUp);
        canvas.off('mouse:over', onMouseOver);
        canvas.off('mouse:out', onMouseOut);
        canvas.off('object:moving', onObjectMoving);
        canvas.off('object:added', onObjectAdd);
        canvas.off('object:scaling', onObjectScaling);
        canvas.off('object:scaled', onObjectScaled);
        canvas.off('object:moved', onObjectMoved);
        canvas.off('object:rotating', onObjectRotating);
        canvas.off('selection:created', onSelect);
        canvas.off('object:modified', onModified);
        canvas.off('selection:updated', onSelectUpdate);
        canvas.off('selection:cleared', onSelectionClear);
        canvas.off('mouse:dblclick', onDbClick);
        canvas.off('text:selection:changed', onSelectionChanged);
        canvas.off('text:editing:exited', onEditingExited);
        canvas.off('text:editing:entered', onEditingEntered);
        canvas.off('text:changed', onTextChanged);
        canvas.off('path:created', onPathCreated);
      }
    };
  }, [
    state.currentState,
    contextState.isEdit,
    state.editGroup,
    state.isShowAlign,
    state.menuPosition,
    state.isShowChart,
    state.isShowChartEdit,
    state.editObj,
    oldTree,
    contextState.isShowEditor,
    stateStack,
    stateBeforeEditText,
    refreshKey,
  ]);

  const dispatchZoom = _.debounce((zoom) => {
    dispatch(updateZoomRatio(zoom));
    eventBus.emit(BUS_EVENTS.UPDATE_ZOOM_SLIDER);
  }, 100);

  const handleZoom = (zoom, e, updateState) => {
    if (window.canvas) {
      const ratio = zoom / 100;
      let positionZoom = { x: 0, y: 0 };
      if (e) {
        positionZoom = window.canvas.getPointer(e, true);
      } else {
        const activeObj = window.canvas.getActiveObject();
        const { scaleX, scaleY, translationX, translationY } = getViewportTransform();
        if (activeObj) {
          activeObj.setCoords();
          const { x, y } = activeObj.getCenterPoint();
          positionZoom = {
            x: x * scaleX + translationX,
            y: y * scaleY + translationY,
          };
        } else {
          const { width, height } = getCurrentViewCanvasSize();
          positionZoom = {
            x: width / 2,
            y: height / 2,
          };
        }
      }
      window.canvas.zoomToPoint(positionZoom, ratio);
      eventBus.emit(BUS_EVENTS.UPDATE_POSITION_MENU_EDITOR);
      if (updateState) dispatchZoom(zoom);
    }
  };

  useEffect(() => {
    eventBus.on(BUS_EVENTS.ZOOM, handleZoom);
    eventBus.on(BUS_EVENTS.UPDATE_HTML_COMPONENT, onUpdateHtmlComponent);
    return () => {
      eventBus.off(BUS_EVENTS.ZOOM, handleZoom);
      eventBus.off(BUS_EVENTS.UPDATE_HTML_COMPONENT, onUpdateHtmlComponent);
    };
  }, []);

  return {
    state: {
      ...state,
      editStyle,
      editText,
      ...contextState,
    },
    setState,
    setContextState,
    onUpdateHtmlComponent,
  };
};
